import { render, staticRenderFns } from "./CopyProviderModal.vue?vue&type=template&id=2d02064a&"
import script from "./CopyProviderModal.vue?vue&type=script&lang=js&"
export * from "./CopyProviderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CopyProviderModal.vue"
export default component.exports